import React from "react";
import { withRouter } from "react-router-dom";
import { Button, Container, Row, Col } from "shards-react";
import axios from 'axios';
import TableAmenities from "../components/amenities/Table";
import FormAmenities from "../components/amenities/Form";
import Styles from "../components/componentStyles/styles.module.css";
import AlertModal from "../components/common/AlertModal";

class Amenities extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            idSelected: null,
            nombreAme: "", activoAme: false, iconoAme: "", ordenAme: "", showForm: false, oneAmeEncontrado: [], ameEncontrado: [],
            loadingData: true,
            showModal: false,
            modalMessage: '',
            modalType: 'info',
            modalTitle: ''
        }
        this.handleChange = this.handleChange.bind(this);
    };

    setField = (name, newValue) => {
        console.log('set field amenitines', name, newValue);
        this.setState({ [name]: newValue });
    };

    showAlert = (message, type = 'info', title = '') => {
        this.setState({
            showModal: true,
            modalMessage: message,
            modalType: type,
            modalTitle: title
        });
    };

    closeModal = () => {
        this.setState({ showModal: false });
    };

    handleChange(nameCheck) {
        const newState = {};
        newState[nameCheck] = !this.state[nameCheck];
        this.setState({ ...this.state, ...newState });
    }

    getAmenities = () => {
        this.setState({ loadingData: true }, () => {
            axios.get(process.env.REACT_APP_PATH + '/api/amenities')
                .then((response) => {
                    setTimeout(() => {
                        this.setState({ ameEncontrado: response.data, loadingData: false })
                    }, 1000);
                })
                .catch((error) => {
                    console.log(error)
                    const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : '¡Error al traer!';
                    this.showAlert(message, 'error');
                });
        })
    };

    componentDidMount() {
        console.log('componentDidMount de ViewAmenities');
        this.getAmenities();
    };

    saveAmenities = () => {
        if (this.state.idSelected) {
            this.updateAmenities();
        } else {
            this.newAmenities();
        }
    };

    newAmenities = () => {
        axios.post(process.env.REACT_APP_PATH + '/api/amenities', {
            nombre: this.state.nombreAme,
            activo: this.state.activoAme,
            icono: this.state.iconoAme,
            orden: this.state.ordenAme
        })
            .then((response) => {
                console.log(response)
                this.setState({ nombreAme: '', ordenAme: '', iconoAme: '', activoAme: false })
                this.showAlert('¡Carga con éxito!', 'success');
                this.cancelFormData();
            })
            .catch((error) => {
                console.log(error)
                const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : '¡No cargado!';
                this.showAlert(message, 'error');
            });
    }

    getOneAmenities = (row) => {
        console.log('id a buscar', row.id);
        axios.get(process.env.REACT_APP_PATH + '/api/oneAmenities', {
            params: {
                id: row.id
            }
        })
            .then((response) => {
                console.log('Trayendo datos', response.data.amenities);
                var amenities = response.data.amenities;
                this.setState({
                    showForm: true,
                    idSelected: amenities.id,
                    nombreAme: amenities.nombre,
                    activoAme: amenities.activo,
                    iconoAme: amenities.icono,
                    ordenAme: amenities.orden,
                    oneAmeEncontrado: response.data
                });
            })
            .catch((error) => {
                console.log(error)
                const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : '¡Error al traer!';
                this.showAlert(message, 'error');
            });
    };

    deleteAmenities = (row) => {
        console.log('id a eliminar', row.id);
        axios.delete(process.env.REACT_APP_PATH + '/api/deleteAmenities', {
            params: {
                id: row.id
            }
        })
            .then((response) => {
                console.log('¡Eliminado!', response);
                this.getAmenities();
            })
            .catch((error) => {
                console.log(error)
                const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : '¡Error al eliminar!';
                this.showAlert(message, 'error');
            });
    };

    updateAmenities = () => {
        var dataToUpdate = {

            id: this.state.idSelected,
            nombre: this.state.nombreAme,
            activo: this.state.activoAme,
            icono: this.state.iconoAme,
            orden: this.state.ordenAme,

        }
        console.log('data a modificar', dataToUpdate)
        axios.put(process.env.REACT_APP_PATH + '/api/updateAmenities', dataToUpdate)
            .then((response) => {
                console.log(response)
                this.showAlert('¡Actualizado!', 'success');
                this.cancelFormData();
            })
            .catch((error) => {
                console.log(error)
                const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : '¡No actualizado!';
                this.showAlert(message, 'error');
            });
    };

    prepareDataForNewAmenities = () => {
        this.setState({ showForm: true, idSelected: null });
    }

    cancelFormData = () => {
        this.setState({ showForm: false, idSelected: null });
        this.getAmenities();
    }

    showButtons = () => {
        if (!this.state.showForm) {
            return (
                <Container fluid className="main-content-container px-4 pb-4">
                    <Row>
                        <Col></Col>
                        <Col md="auto">&nbsp;</Col>
                        <Col xs lg="2">
                            <Button
                                className={Styles.buttonView}
                                onClick={() => this.prepareDataForNewAmenities()}
                                theme="primary" >
                                Nueva Amenity
                            </Button>
                        </Col>
                    </Row>
                </Container>
            )
        }

        return null;

    };

    render() {
        console.log('render view functional');
        return (
            <div>
                {!this.state.showForm && <TableAmenities loadingData={this.state.loadingData} getOneAmenities={this.getOneAmenities} data={this.state.ameEncontrado} getAmenities={this.getAmenities} deleteAmenities={this.deleteAmenities} />}

                {this.showButtons()}

                {this.state.showForm &&
                    <FormAmenities saveAmenities={this.saveAmenities} setField={this.setField}
                        handleChangeCheckbox={this.handleChange}
                        handleFileChange={this.handleFileChange}
                        amenities={{
                            nombreAme: this.state.nombreAme, activoAme: this.state.activoAme, iconoAme: this.state.iconoAme,
                            ordenAme: this.state.ordenAme
                        }}
                        cancelFormData={this.cancelFormData}
                    />}
                
                <AlertModal
                    show={this.state.showModal}
                    message={this.state.modalMessage}
                    type={this.state.modalType}
                    title={this.state.modalTitle}
                    onClose={this.closeModal}
                />
            </div>
        )
    };

}

export default withRouter(Amenities);
